export const SETTLE_MARGIN_MS = 50;

function milliseconds(value: CSSNumberish | null | undefined): number {
  return typeof value === "number" && Number.isFinite(value) ? value : 0;
}

function remainingAnimationMs(element: Element): number {
  if (typeof element.getAnimations !== "function") return 0;
  return element.getAnimations().reduce((longest, animation) => {
    const end = milliseconds(animation.effect?.getComputedTiming().endTime);
    return Math.max(longest, end - milliseconds(animation.currentTime));
  }, 0);
}

/** Longest remaining transition time on `shell` and its direct children, in milliseconds. */
export function remainingMoveMs(shell: HTMLElement): number {
  return [shell, ...shell.children].reduce(
    (longest, element) => Math.max(longest, remainingAnimationMs(element)),
    0,
  );
}
